var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hydrated)?_c('loading'):_c('app')
}
var staticRenderFns = []

export { render, staticRenderFns }